import { palette } from "./index";

export const antdSharedTheme = {
  token: {
    colorPrimary: palette.primary,
    colorInfo: palette.primary,
    colorLink: palette.primary,
    colorSuccess: palette.success,
    colorWarning: palette.warning,
    colorError: palette.danger,
    colorBorder: palette.border,
    colorText: palette.textPrimary,
    colorTextSecondary: palette.textSecondary,
    colorBgContainer: palette.surface,
    fontFamily: "var(--font-body)",
  },
};

export const getAntdDatePickerTheme = (componentOverrides = {}) => ({
  ...antdSharedTheme,
  components: {
    DatePicker: {
      colorPrimary: palette.primary,
      colorPrimaryHover: palette.primaryHover,
      activeBorderColor: palette.primary,
      hoverBorderColor: palette.primaryHover,
      activeShadow: `0 0 0 2px ${palette.primaryLight}`,
      cellHoverWithRangeBg: palette.primaryLight,
      cellActiveWithRangeBg: palette.primaryLight,
      cellRangeBorderColor: palette.primary,
      colorText: palette.textPrimary,
      colorTextPlaceholder: palette.textSecondary,
      ...componentOverrides,
    },
  },
});

export default antdSharedTheme;
